import api from '../httpClient';

export type UserTourStatus = 'dismissed' | 'completed';

export type UserTourProgressRecord = {
  tour_key: string;
  status: UserTourStatus;
  completed_at: string | null;
  updated_at: string;
};

export const userTours = {
  list: () =>
    api.get<UserTourProgressRecord[]>('/api/user/tours/').then((response) => response.data),
  update: (tourKey: string, status: UserTourStatus) =>
    api
      .patch<UserTourProgressRecord>(`/api/user/tours/${encodeURIComponent(tourKey)}/`, { status })
      .then((response) => response.data),
};
